import {
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import React from "react";
import { thStyle } from "../../helpers/constants";
import PromoCodeListRow from "./PromoCodeListRow";

interface Props {
  codes: PromoCode[];
  onSelect: (id: string, state: "add" | "remove") => void;
}

export default function PromoCodeList(props: Props) {
  const { codes, onSelect } = props;

  return (
    <CTable responsive hover align="middle" className="mb-0">
      <CTableHead>
        <CTableRow>
          <CTableHeaderCell style={thStyle}>Code</CTableHeaderCell>
          <CTableHeaderCell style={thStyle}>Type</CTableHeaderCell>
          <CTableHeaderCell style={thStyle}>Valable pour</CTableHeaderCell>
          <CTableHeaderCell style={thStyle}>Réduction (%)</CTableHeaderCell>
          <CTableHeaderCell style={thStyle}>Utilisations max</CTableHeaderCell>
          <CTableHeaderCell style={{ ...thStyle, textAlign: "right" }}>
            Actions
          </CTableHeaderCell>
        </CTableRow>
      </CTableHead>
      <CTableBody>
        {codes?.map((promoCode) => (
          <PromoCodeListRow
            promoCode={promoCode}
            key={promoCode?.id}
            onSelect={onSelect}
          />
        ))}
      </CTableBody>
    </CTable>
  );
}
